import { useCallback, useRef } from 'react';
import { useWindowEvent } from '../useWindowEvent';

export const useGlobalKeyHandler = (keyName: string, callback?: VoidFunction) => {
  /** We save the callback to a ref to avoid needing to update the window event when it changes */
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const innerHandler = useCallback(
    (event: KeyboardEvent) => {
      if (callbackRef.current && event.key === keyName) {
        event.preventDefault();
        callbackRef.current();
      }
    },
    [keyName],
  );

  useWindowEvent('keydown', innerHandler);
};
